<template>
    <!-- begin:: Header -->
    <div
            id="kt_header"
            ref="kt_header"
            class="header d-flex justify-content-between"
            v-bind:class="headerClasses"
    >
        <div class="d-none d-md-block">
            <KTAside v-if="asideEnabled"></KTAside>
        </div>
        <div
                class="d-flex align-items-center justify-content-between"
                v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
        >
            <button
                    class="btn col-md-1 d-none d-md-block hiddenIn990"
                    id="kt_aside_mobile_toggle"
                    @click="toggleNavigation()"
            >
                <i class="fa fa-bars" style="font-size: 15pt"></i>
                <span class="text-white mr-2" >منو</span>
            </button>

            <div class="d-flex align-items-stretch mr-3">
                <div class="header-logo">
                    <router-link to="/">
                        <img
                                alt="Logo"
                                :src="require('/public/media/logo.png')"
                                class="logo-default max-h-40px"
                        />
                        <img
                                alt="Logo"
                                :src="require('/public/media/logo.png')"
                                class="logo-sticky max-h-40px"
                        />
                    </router-link>
                </div>
                <!-- begin:: Header Menu -->
                <div
                        class="header-menu-wrapper header-menu-wrapper-left"
                        ref="kt_header_menu_wrapper"
                >

                    <div
                            v-if="headerMenuEnabled"
                            id="kt_header_menu"
                            ref="kt_header_menu"
                            class="header-menu header-menu-mobile"
                            v-bind:class="headerMenuClasses"
                    >
                        <!-- example static menu here -->
                        <KTMenu></KTMenu>
                    </div>
                </div>
                <!-- end:: Header Menu -->
            </div>
            <KTTopbar></KTTopbar>
        </div>
        <div class="hiddenIn990 d-flex align-items-center ml-5">
            <KTExitButton></KTExitButton>
        </div>
    </div>
    <!-- end:: Header -->
</template>

<script>
import {mapGetters} from "vuex";
import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";
import KTMenu from "@/view/layout/header/Menu.vue";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTExitButton from "@/view/layout/header/ExitButton.vue"


export default {
    name: "KTHeader",
    components: {
        KTTopbar,
        KTMenu,
        KTAside,
        KTExitButton
    },
    mounted() {
        // Init Desktop & Mobile Headers
        KTLayoutHeader.init("kt_header", "kt_header_mobile");

        // Init Header Menu
        KTLayoutHeaderMenu.init(
            this.$refs["kt_header_menu"],
            this.$refs["kt_header_menu_wrapper"]
        );

        const headerRef = this.$refs["kt_header"];

        headerRef.querySelectorAll("a[class='menu-link']").forEach(item => {
            item.addEventListener("click", () => {
                KTLayoutHeaderMenu.getOffcanvas().hide();
            });
        });
    },
    computed: {
        ...mapGetters(["layoutConfig", "getClasses"]),
        asideEnabled() {
            return !!this.layoutConfig("aside.self.display");
        },
        /**
         * Check if the header menu is enabled
         * @returns {boolean}
         */
        headerMenuEnabled() {
            return !!this.layoutConfig("header.menu.self.display");
        },

        /**
         * Get extra classes for header based on the options
         * @returns {null|*}
         */
        headerClasses() {
            const classes = this.getClasses("header");
            if (typeof classes !== "undefined") {
                return classes.join(" ");
            }
            return null;
        },

        /**
         * Get extra classes for header menu based on the options
         * @returns {null|*}
         */
        headerMenuClasses() {
            const classes = this.getClasses("header_menu");
            if (typeof classes !== "undefined") {
                return classes.join(" ");
            }
            return null;
        },

        /**
         * Check if header container is fluid
         */
        widthFluid() {
            return this.layoutConfig("header.self.width") === "fluid";
        }
    },
    methods: {
        toggleSecondMenu: function () {
            const a = document.getElementById('kt_content')
            const b = document.getElementById('kt_aside')
            if (a.classList.contains('flex-column') && b.classList.contains('d-md-none')) {
                b.classList.remove('d-md-none');
                a.classList.remove('flex-column');
            } else if (b.classList.contains('d-block')) {
                b.classList.add('d-md-none');
                a.classList.add('flex-column');
            }
        }
    }
};
</script>

<style scoped>
@media only screen and (max-width: 990px) {
    .hiddenIn990 {
        display: none !important;
    }
}
</style>